import { motion } from 'framer-motion';
import { AlertCircle, ArrowRight } from 'lucide-react';

const SuspendedSectionLight = () => {
  return (
    <section className="py-16 bg-slate-50 border-y border-slate-100" data-testid="suspended-section">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-2xl border-2 border-orange-300 bg-gradient-to-br from-orange-50 to-red-50 p-8 md:p-12"
        >
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
            {/* Icon */}
            <div className="flex-shrink-0">
              <div className="w-16 h-16 rounded-xl bg-orange-100 border border-orange-200 flex items-center justify-center">
                <AlertCircle className="w-8 h-8 text-orange-500" />
              </div>
            </div>
            
            {/* Content */}
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl md:text-3xl font-display text-slate-800 mb-2">
                Suspended and need to be reinstated?
              </h3>
              <p className="text-slate-600 text-lg">
                Try our customized Plan of Action for only <span className="text-orange-600 font-semibold">$197</span>
              </p>
            </div>
            
            {/* CTA Button */}
            <div className="flex-shrink-0">
              <a
                href="https://poa.section3.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 font-semibold text-white bg-orange-500 hover:bg-orange-600 rounded-full transition-all hover:scale-105 shadow-lg shadow-orange-500/30"
                data-testid="poa-cta-btn"
              >
                Get Your POA
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SuspendedSectionLight;
